/**
 * OrgSettingsPage.tsx — Redirect to overview (settings are now in the header dropdown)
 * @since 2026-06-20
 */
import React from 'react';
import { Navigate } from 'react-router-dom';

export default function OrgSettingsPage(): React.JSX.Element {
  return <Navigate to="/overview" replace />;
}
